import React from 'react';
import { getToken } from 'src/utils/helpers';
import { observer } from 'src/utils/mobx-react';
import { computed, observable, makeAutoObservable } from 'mobx';
import { z } from 'zod';

import {
    McBookieSwitch,
    StarSportsSwitch,
    UniverseSwitcherAvailable,
    UniverseSwitcherItem,
    SwitchIconWrapper,
} from './UniverseSwitchers.style';
import { UniverseType, UniverseZod } from 'src_common/common/universe';
import { AppState, useAppStateContext } from 'src/AppState/AppState';

const getIsTokenGenerateAvailable = (universe: UniverseType): boolean => {
    interface UniverseItemConfigType {
        id: UniverseType;
        // label: string;
        isTokenGenerateAvailable?: boolean;
    }

    const AVAILABLE_UNIVERSES: Array<UniverseItemConfigType> = [
        {
            id: 'mcbookie',
            // label: 'McBookie',
            isTokenGenerateAvailable: true,
        },
        {
            id: 'star',
            // label: 'StarSports',
        },
    ];

    for (const item of AVAILABLE_UNIVERSES) {
        if (item.id === universe) {
            return item.isTokenGenerateAvailable ?? false;
        }
    }

    return false;
};

const UniverseList = z.array(UniverseZod);

class State {
    @observable public isDropdownShown: boolean = false;

    public constructor(private readonly appState: AppState) {
        makeAutoObservable(this);
    }

    @computed.struct public get linkedUniversesFromRedux(): Array<UniverseType> {
        const userData = this.appState.reduxStore.getStateReactive().user;

        if (userData === undefined) {
            return [];
        }

        try {
            //@ts-expect-error - This is where the data is collected from redux
            const resultIm = userData.getIn(['data', 'linkedUniverses']);

            if (resultIm === undefined) {
                return [];
            }

            const result = resultIm.toJS();

            if (result === undefined) {
                return [];
            }

            const data = UniverseList.safeParse(result);

            if (data.success) {
                return data.data;
            }

            console.error('linkedUniverses - incorrect data', result);
        } catch (error) {
            console.error('linkedUniverses - js runtime', error);
        }

        return [];
    }

    @computed.struct public get linkedUniverses(): Array<UniverseType> {
        const selectedUniverse = this.appState.universe_api;

        return this.linkedUniversesFromRedux.filter((universe) => universe !== selectedUniverse);
    }

    public toggleDropDown = (): void => {
        this.isDropdownShown = !this.isDropdownShown;
    };

    public switchUniverse = (universe: UniverseType, event: React.SyntheticEvent): void => {
        event.preventDefault();

        const token = getToken();
        const domain = window.location.origin.replace(this.appState.universe_api, universe);
        const isTokenGenerateAvailable = getIsTokenGenerateAvailable(universe);

        let url = `${domain}/universe-switcher`;

        if (isTokenGenerateAvailable && token !== null) {
            url = `${url}?universe=${universe}&token=${token}`;
        }

        window.open(url);

        this.isDropdownShown = false;
    };
}

export const UniverseSwitcher = observer('UniverseSwitcher', () => {
    const appState = useAppStateContext();
    const [state] = React.useState(() => new State(appState));

    const isDropdownShown = state.isDropdownShown;

    if (state.linkedUniverses.length < 1) {
        return <div> </div>;
    }

    const listUniverses: Array<JSX.Element> = [];

    for (const universeId of state.linkedUniverses) {
        listUniverses.push(
            <UniverseSwitcherItem
                href='#'
                key={universeId}
                onClick={(event: React.SyntheticEvent) => state.switchUniverse(universeId, event)}
            >
                {universeId === 'mcbookie' ? <McBookieSwitch /> : undefined}
                {universeId === 'star' ? <StarSportsSwitch /> : undefined}
            </UniverseSwitcherItem>
        );
    }

    return (
        <>
            <SwitchIconWrapper onClick={state.toggleDropDown} />
            {isDropdownShown ? <UniverseSwitcherAvailable>{listUniverses}</UniverseSwitcherAvailable> : null}
        </>
    );
});
